export default __webpack_public_path__ + "static/media/lovetolii.54848fd8.png";